// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ni[data-v-b1f6c15e]:hover {\r\n  cursor: pointer\n}\nel-button[data-v-b1f6c15e] {\n}\r\n", ""]);
// Exports
module.exports = exports;
